var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vwc-dialog",
    {
      directives: [
        {
          name: "observe-keyboard",
          rawName: "v-observe-keyboard.l2.enter",
          value: _vm.primaryAction,
          expression: "primaryAction",
          modifiers: { l2: true, enter: true },
        },
      ],
      staticClass: "vvd-scheme-alternate dialog",
      attrs: {
        "data-cy": "error-modal",
        "close-button": _vm.showCancelButton,
        open: _vm.errorDialog,
        heading: _vm.$t("error_modal.title"),
      },
      on: {
        closed: _vm.hide,
        click: function ($event) {
          $event.stopPropagation()
        },
      },
    },
    [
      _c("vwc-icon", {
        staticClass: "dialog-icon",
        attrs: { slot: "icon", size: "large", type: "warning-line" },
        slot: "icon",
      }),
      _c("div", { staticClass: "content" }, [
        _c("div", { staticClass: "text" }, [
          _vm._v(_vm._s(_vm.errorDialog.text)),
        ]),
      ]),
      _c("vwc-button", {
        attrs: {
          slot: "secondaryAction",
          "data-cy": "cancel-btn",
          label: _vm.$t("error_modal.cancel_btn"),
          layout: "outlined",
          type: "submit",
        },
        on: { click: _vm.hide },
        slot: "secondaryAction",
      }),
      _c("vwc-button", {
        attrs: {
          slot: "primaryAction",
          "data-cy": "primary-btn",
          label: _vm.errorDialog.primaryButtonText,
          layout: "filled",
          connotation: "primary",
          icon: _vm.errorDialog.primaryButtonIcon,
          type: "submit",
        },
        on: { click: _vm.primaryAction },
        slot: "primaryAction",
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }